import script from "./WageChart.vue?vue&type=script&setup=true&lang=js"
export * from "./WageChart.vue?vue&type=script&setup=true&lang=js"

import "./WageChart.vue?vue&type=style&index=0&id=e5f7bf46&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5f7bf46"]])

export default __exports__